import * as FIELD_NAME from 'constant/form-item-names'
import * as NUMBER from 'constant/number'
import * as RULES from 'constant/form-rules'
import React from 'react'
import { Form, Input } from 'antd'
import PropTypes from 'prop-types'
import styles from '../styles.scss'

const IntroductionInput = ({ name = FIELD_NAME.INTRODUCTION, title = 'Introduction' }) => {
  return (
    <>
      <span>{title}</span>
      <Form.Item
        name={name}
        rules={[RULES.REQUIRED, RULES.maxCharLength(NUMBER.THREE_NINE_ZERO)]}
      >
        <Input.TextArea
          className={styles.form_textarea}
          placeholder={title}
          rows={NUMBER.FOUR}
        />
      </Form.Item>
    </>
  )
}

IntroductionInput.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string
}

export default IntroductionInput
